import API from "../api/apiUser";

/**
 * Service for fetching public event data.
 */
export const UserEventsService = {
    /**
     * Fetches all events/tour dates for the public events page.
     * @returns {Promise<Array>} List of event objects.
     */
    getAllEvents: async () => {
        try {
            const response = await API.get("/user/events");
            return response.data;
        } catch (error) {
            console.error("Error fetching events:", error);
            throw error;
        }
    }
};
